/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Managed object
 */
export interface ManagedObjectDTO { 
    /**
     * ManagedObjectType:  * `tenant` - Tenant  * `organization` - Organization  * `businesspremises` - Business Premises 
     */
    managedObjectType: ManagedObjectDTOManagedObjectTypeEnum;
    /**
     * Managed Object Id
     */
    managedObjectId: string;
}

export class ClsManagedObjectDTO { 
    /**
     * ManagedObjectType:  * `tenant` - Tenant  * `organization` - Organization  * `businesspremises` - Business Premises 
     */
    managedObjectType: ManagedObjectDTOManagedObjectTypeEnum = undefined;
    /**
     * Managed Object Id
     */
    managedObjectId: string = undefined;
}
export enum ManagedObjectDTOManagedObjectTypeEnum {
    TENANT = 'tenant',
    ORGANIZATION = 'organization',
    BUSINESSPREMISES = 'businesspremises'
}

export class ClsManagedObjectDTOManagedObjectTypeEnum {
    TENANT = 'tenant';
    ORGANIZATION = 'organization';
    BUSINESSPREMISES = 'businesspremises';
};



